module.exports = __webpack_public_path__ + "media/promo/hochland/images/l4-b1c30a6f703bdeca984bd8ad413cd14f.png";